/* NOT TOYS 2026 · content pages (L4, 22 Oct): collaboration pages and About. Small, no libraries.
   - room for a fixed theme header (a sticky one already takes its own room)
   - the arrows on swipe rows, the gentle photo zoom on "How it's made"
   - Dolls & Dons: "View artwork" opens the artist's own words in a panel on this page */
(() => {
  'use strict';
  if (window.__ntPages) return; window.__ntPages = 1;   // every page section links this file; run once
  const roots = [...document.querySelectorAll('.ntp')];
  if (!roots.length) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- header room
  const pos = (el) => getComputedStyle(el).position;
  const findHdr = () => {
    const list = [...document.querySelectorAll('[data-nt-header], .shopify-section-group-header-group, #shopify-section-header, header')].filter((el) => !el.closest('.ntp'));
    for (const el of list) { if (pos(el) === 'fixed') return el; for (const ch of el.children) if (pos(ch) === 'fixed') return ch; }
    return null;
  };
  // the shell's header floats over the page (its section is 0 high): measure the visible glass bar, #top .row (sticky, so its
  // bottom is the same at any scroll), and pad the first section by whatever part of it the bar would cover
  const barRow = () => { const r = document.querySelector('#top .row'); return r && !r.closest('.ntp') ? r : null; };
  const pad = () => {
    const first = roots[0], row = barRow(), h = row ? null : findHdr();
    let p = 0;
    if (row) { const rb = row.getBoundingClientRect(); if (rb.height && rb.bottom > 0) p = Math.max(0, Math.round(rb.bottom - (first.getBoundingClientRect().top + scrollY))); }
    else if (h) { const hb = h.offsetHeight + Math.max(0, parseFloat(getComputedStyle(h).top) || 0); p = Math.max(0, Math.round(hb - (first.getBoundingClientRect().top + scrollY))); }
    first.style.setProperty('--nppad', p + 'px');
  };
  pad(); addEventListener('resize', pad); addEventListener('load', pad);

  // ---------- arrows on swipe rows
  document.querySelectorAll('.ntp .arw[data-for]').forEach((a) => {
    const row = document.getElementById(a.dataset.for), pv = a.querySelector('.pv'), nx = a.querySelector('.nx');
    if (!row || !pv || !nx) return;
    const sync = () => { pv.disabled = row.scrollLeft < 4; nx.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4; };
    pv.addEventListener('click', () => row.scrollBy({ left: -row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }));
    nx.addEventListener('click', () => row.scrollBy({ left: row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }));
    row.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    addEventListener('resize', sync); sync();
  });

  // ---------- How it's made: each photo settles as it comes into view
  const steps = document.querySelectorAll('.ntp .mk-step, .ntp .mk-fin');
  if (steps.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => e.target.classList.toggle('in', e.isIntersecting)), { threshold: 0.25 });
    steps.forEach((el) => io.observe(el));
  } else steps.forEach((el) => el.classList.add('in'));

  // ---------- a photo that is missing steps aside (its card hides, a missing hero becomes the thin gold line)
  document.querySelectorAll('.ntp img[data-miss]').forEach((im) => {
    const miss = () => {
      const k = im.dataset.miss;
      if (k === 'card') { const c = im.closest('.co-card, .dd-card'); if (c) c.hidden = true; }
      else if (k === 'hero') { const f = im.closest('.co-fig'); if (f) f.classList.add('noimg'); }
      else if (k === 'thumb') { const p = im.parentNode; p.classList.add('noimg'); im.remove(); }
    };
    if (im.complete && im.naturalWidth === 0 && im.getAttribute('src')) miss(); else im.addEventListener('error', miss, { once: true });
  });

  // ---------- Dolls & Dons: the artist panel
  const dlg = document.getElementById('ddDlg');
  if (dlg) {
    let from = null;
    document.addEventListener('click', (ev) => {
      const b = ev.target.closest('.ntp .dd-view[data-tpl]');
      if (!b) return;
      const t = document.getElementById(b.dataset.tpl);
      if (!t) return;
      dlg.innerHTML = t.innerHTML;
      from = b;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      dlg.scrollTop = 0;
      const x = dlg.querySelector('.dd-x'); if (x) x.focus();
    });
    dlg.addEventListener('click', (ev) => {
      if (ev.target === dlg || ev.target.closest('[data-close]')) { if (typeof dlg.close === 'function') dlg.close(); else { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); } }
    });
    dlg.addEventListener('close', () => { if (from && document.contains(from)) from.focus({ preventScroll: true }); from = null; });
  }
})();
